module.exports = __webpack_public_path__ + "media/flags/hm-9a25dd69.svg";